import { useState } from "react";
import { toast } from "sonner";
import { adminShop, errMsg } from "../../lib/shopApi";
import { btn, inputCls } from "./shared";

export const PrintedMintPanel = ({ order, passcode, onUpdated }) => {
  const pm = order.printed_mint;
  const [f, setF] = useState({ carrier: "USPS", tracking_number: "", tracking_url: "", pm_order_ref: pm.pm_order_ref || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const pmLines = order.lines.filter((l) => l.supplier === "printed_mint");

  const call = async (fn, body, msg) => {
    setBusy(true);
    try { onUpdated(await fn(order.id, body, passcode)); toast(msg); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded border border-[#E9C46A] bg-[#FFFBEF] p-4" data-testid="admin-order-pm-panel">
      <p className="font-display text-lg text-[#4B3A2F] mb-1">Printed Mint — placed by you</p>
      <p className="text-sm mb-2" data-testid="admin-order-pm-status">Status: <b>{pm.status.replace("_", " ")}</b></p>
      <ul className="text-sm list-disc pl-5 mb-3">
        {pmLines.map((l) => <li key={l.variant_id}>{l.title} · {l.variant_label} × {l.quantity}</li>)}
      </ul>
      {pm.status === "shipped" ? (
        <p className="text-sm">Shipped · {pm.carrier} · {pm.tracking_number} — see History for the customer email.</p>
      ) : (
        <div className="space-y-2">
          {pm.status === "awaiting_placement" && (
            <div className="flex gap-2">
              <input className={inputCls} placeholder="Printed Mint order # (optional)" value={f.pm_order_ref} onChange={set("pm_order_ref")} data-testid="admin-order-pm-ref" />
              <button type="button" className={btn.ghost} disabled={busy} onClick={() => call(adminShop.pmPlaced, { pm_order_ref: f.pm_order_ref }, "Marked as placed.")} data-testid="admin-order-pm-placed">I placed it</button>
            </div>
          )}
          <div className="grid grid-cols-2 gap-2">
            <input className={inputCls} placeholder="Carrier" value={f.carrier} onChange={set("carrier")} data-testid="admin-order-pm-carrier" />
            <input className={inputCls} placeholder="Tracking number" value={f.tracking_number} onChange={set("tracking_number")} data-testid="admin-order-pm-tracking" />
            <input className={`${inputCls} col-span-2`} placeholder="Tracking link (optional)" value={f.tracking_url} onChange={set("tracking_url")} data-testid="admin-order-pm-tracking-url" />
          </div>
          <button type="button" className={btn.primary} disabled={busy || !f.tracking_number} onClick={() => call(adminShop.pmShipped, f, "Marked shipped.")} data-testid="admin-order-pm-shipped">
            Mark shipped & email customer
          </button>
        </div>
      )}
    </div>
  );
};
